"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AdvancedTableWrapper = exports.default = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _debounce = _interopRequireDefault(require("debounce"));

var _react = _interopRequireDefault(require("react"));

var _AdvancedTable = _interopRequireDefault(require("./AdvancedTable"));

var _Button = _interopRequireDefault(require("../Button/Button"));

var _SkeletonLoader = _interopRequireDefault(require("../SkeletonLoader"));

var _AdvancedTableWrapperConstants = require("./AdvancedTableWrapperConstants");

var _notistack = require("notistack");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var AdvancedTableWrapper = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2.default)(AdvancedTableWrapper, _React$Component);

  var _super = _createSuper(AdvancedTableWrapper);

  // Dont put in react state, setState call causes re-render when typing.
  function AdvancedTableWrapper(props) {
    var _this;

    (0, _classCallCheck2.default)(this, AdvancedTableWrapper);
    _this = _super.call(this, props);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "search", "");
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "page", 0);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "preloadedData", new Map());
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "preloadedDataClearer", void 0);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "ref", void 0);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "defaultColumnOptions", {
      sort: false,
      filter: false
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "hiddenColumns", {});
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "setLoading", function () {
      var loading = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

      _this.setState({
        loading: loading
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "scrollToTop", function () {
      if (_this.ref && _this.ref.current) {
        _this.ref.current.scrollIntoView({
          block: "start",
          behavior: "smooth"
        });
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "loadRows", /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
      var showLoader,
          retrieved,
          wasPreloaded,
          _state,
          _args = arguments;

      return _regenerator.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              showLoader = _args.length > 0 && _args[0] !== undefined ? _args[0] : true;
              retrieved = null;
              _context.prev = 2;

              _this.deselectAllRows();

              if (!(_this.props.serverSide || !_this.state.dataRetrieved)) {
                _context.next = 18;
                break;
              }

              if (showLoader) {
                _this.setLoading();
              }

              _state = _this.tableState;
              retrieved = _this.props.enablePreload ? _this.getPreloadedData(_state) : null;
              wasPreloaded = retrieved != null;

              if (retrieved) {
                _context.next = 13;
                break;
              }

              _context.next = 12;
              return _this.props.rows(_this.tableState);

            case 12:
              retrieved = _context.sent;

            case 13:
              if (!(retrieved.status === _AdvancedTableWrapperConstants.RowStatus.Loading)) {
                _context.next = 15;
                break;
              }

              return _context.abrupt("return");

            case 15:
              if (!wasPreloaded) {
                _this.preloadedData.set(JSON.stringify(_state), {
                  data: retrieved,
                  timestamp: Date.now()
                });
              }

              _this.setState({
                dataRetrieved: true,
                retrievedRows: retrieved.data,
                count: retrieved.count
              });

              setTimeout(_this.preloadNextPage, 0);

            case 18:
              _context.next = 23;
              break;

            case 20:
              _context.prev = 20;
              _context.t0 = _context["catch"](2);

              if (_this.props.onError) {
                _this.props.onError(_context.t0);
              } else {
                _this.props.enqueueSnackbar(_context.t0.toString(), {
                  variant: "error"
                });
              }

            case 23:
              _context.prev = 23;

              if (retrieved && retrieved.status !== _AdvancedTableWrapperConstants.RowStatus.Loading && showLoader) {
                _this.setLoading(false);
              }

              return _context.finish(23);

            case 26:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[2, 20, 23, 26]]);
    })));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "deleteRowByFilter", /*#__PURE__*/function () {
      var _ref2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2(filter, func, success) {
        var i;
        return _regenerator.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                i = _this.setRowLoadingByFilter(filter);
                _context2.next = 3;
                return func();

              case 3:
                _this.setState(function (prevState) {
                  var rows = (0, _toConsumableArray2.default)(prevState.retrievedRows);
                  rows.splice(i, 1);

                  _this.preloadedData.delete(JSON.stringify(_this.tableState));

                  if (_this.props.serverSide) {
                    if (rows.length + 1 < _this.state.rowsPerPage) {
                      _this.loadRows(false);
                    }
                  }

                  return {
                    retrievedRows: rows,
                    count: _this.state.count - 1
                  };
                });

                _this.props.enqueueSnackbar(success, {
                  variant: "success"
                });

              case 5:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      return function (_x, _x2, _x3) {
        return _ref2.apply(this, arguments);
      };
    }());
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "deleteRow", /*#__PURE__*/function () {
      var _ref3 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee3(index) {
        return _regenerator.default.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this.setState(function (prevState) {
                  var rows = (0, _toConsumableArray2.default)(prevState.retrievedRows);
                  rows.splice(index, 1);

                  _this.preloadedData.delete(JSON.stringify(_this.tableState));

                  return {
                    retrievedRows: rows,
                    count: _this.state.count - 1
                  };
                });

              case 1:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      return function (_x4) {
        return _ref3.apply(this, arguments);
      };
    }());
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "reloadRow", /*#__PURE__*/function () {
      var _ref4 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee4(index, row) {
        return _regenerator.default.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _this.setState(function (prevState) {
                  var rows = (0, _toConsumableArray2.default)(prevState.retrievedRows);
                  rows.splice(index, 1, row);

                  _this.preloadedData.delete(JSON.stringify(_this.tableState));

                  return {
                    retrievedRows: rows
                  };
                });

              case 1:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }));

      return function (_x5, _x6) {
        return _ref4.apply(this, arguments);
      };
    }());
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "setRowLoadingByFilter", function (filter) {
      var i = _this.state.retrievedRows.findIndex(filter);

      _this.setState(function (prevState) {
        var rows = (0, _toConsumableArray2.default)(prevState.retrievedRows);
        rows[i] = rows.map(function (row, index) {
          return /*#__PURE__*/_react.default.createElement(_SkeletonLoader.default, {
            key: index
          });
        });
        return {
          retrievedRows: rows
        };
      });

      return i;
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "setRowLoading", function (index) {
      _this.setState(function (prevState) {
        var rows = (0, _toConsumableArray2.default)(prevState.retrievedRows);
        rows[index] = rows.map(function (row, index) {
          return /*#__PURE__*/_react.default.createElement(_SkeletonLoader.default, {
            key: index
          });
        });
        return {
          retrievedRows: rows
        };
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "debouncedSearch", (0, _debounce.default)(_this.loadRows, 400));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "buildLoadingColumns", function () {
      var newColumns = _this.props.columns.map(function (c, index) {
        var newColumn = _objectSpread(_objectSpread({}, c), {}, {
          options: _objectSpread(_objectSpread({}, c.options), {}, {
            customBodyRender: function customBodyRender() {
              return /*#__PURE__*/_react.default.createElement(_SkeletonLoader.default, {
                key: index
              });
            }
          })
        });

        return newColumn;
      });

      return newColumns;
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "buildColumns", function () {
      var newColumns = _this.props.columns.map(function (c, index) {
        var newColumn = _objectSpread({}, c);

        if (!c.options) {
          newColumn.options = _objectSpread({}, _this.defaultColumnOptions);
        } else {
          newColumn.options = _objectSpread(_objectSpread(_objectSpread({}, _this.defaultColumnOptions), c.options), {}, {
            filterList: _this.state.filterList[index],
            display: _this.hiddenColumns[c.name]
          });
        }

        return newColumn;
      });

      var _this$state = _this.state,
          sortDirection = _this$state.sortDirection,
          sortColumnIndex = _this$state.sortColumnIndex;

      if (sortDirection && newColumns[sortColumnIndex]) {
        newColumns[sortColumnIndex]["options"] = newColumns[sortColumnIndex]["options"] || {};
        newColumns[sortColumnIndex]["options"]["sort"] = true;
        newColumns[sortColumnIndex]["options"]["sortDirection"] = sortDirection;
      }

      return newColumns;
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onDownload", function () {
      _this.props.onDownload && _this.props.onDownload();
      return false;
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "getPreloadedData", function (state) {
      var data = _this.preloadedData.get(JSON.stringify(state));

      if (!data) {
        return null;
      }

      var diff = Date.now() - data.timestamp; // Expire the preloaded data after 15 seconds.

      if (diff > _this.state.preloadedDataExpirationSeconds * 1000) {
        return null;
      }

      return data.data;
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "startPreloadedDataClearer", function () {
      if (!_this.props.enablePreload) {
        return;
      }

      if (_this.preloadedDataClearer) {
        clearInterval(_this.preloadedDataClearer);
      }

      _this.preloadedDataClearer = setInterval(function () {
        _this.preloadedData.forEach(function (value, key) {
          var diff = Date.now() - value.timestamp; // Expire the preloaded data if it has been in the map longer than X amount of seconds.

          if (diff > _this.state.preloadedDataExpirationSeconds * 1000) {
            _this.preloadedData.delete(key);
          }
        });
      }, 15 * 1000);
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "preloadNextPage", /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee5() {
      var state, totalPages, newState, newRows;
      return _regenerator.default.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              if (_this.props.enablePreload) {
                _context5.next = 2;
                break;
              }

              return _context5.abrupt("return");

            case 2:
              state = _this.tableState;
              totalPages = Math.round(_this.state.count / state.rowsPerPage);

              if (!(totalPages <= state.page)) {
                _context5.next = 6;
                break;
              }

              return _context5.abrupt("return");

            case 6:
              newState = _objectSpread({}, state);
              newState.page += 1;
              _context5.next = 10;
              return _this.props.rows(newState);

            case 10:
              newRows = _context5.sent;

              _this.preloadedData.set(JSON.stringify(newState), {
                data: newRows,
                timestamp: Date.now()
              });

            case 12:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5);
    })));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onSearch", /*#__PURE__*/function () {
      var _ref6 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee6(text) {
        return _regenerator.default.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _this.search = text;

                if (!(text && text.trim().length < (_this.props.minSearchLength || 3))) {
                  _context6.next = 3;
                  break;
                }

                return _context6.abrupt("return");

              case 3:
                _this.page = 0;
                _this.state.enableDebounce ? _this.debouncedSearch() : _this.loadRows();

              case 5:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6);
      }));

      return function (_x7) {
        return _ref6.apply(this, arguments);
      };
    }());
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "buildOptions", function () {
      var options = {
        download: _this.props.download || false,
        onDownload: _this.onDownload,
        print: false,
        onColumnViewChange: function onColumnViewChange(column, action) {
          //Update props to keep paging up to date
          var item = _this.props.columns[_this.props.columns.findIndex(function (c) {
            return c.name === column;
          })];

          if (item.options === undefined) {
            item.options = {};
          }

          item.options.display = action === "add" ? "true" : "false"; //Update hiddenColumns to keep filtering up to date

          _this.hiddenColumns[column] = item.options.display;
        },
        onTableChange: function () {
          var _onTableChange = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee7(action, state) {
            var split, column, direction;
            return _regenerator.default.wrap(function _callee7$(_context7) {
              while (1) {
                switch (_context7.prev = _context7.next) {
                  case 0:
                    _context7.t0 = action;
                    _context7.next = _context7.t0 === "changePage" ? 3 : _context7.t0 === "sort" ? 8 : _context7.t0 === "search" ? 15 : _context7.t0 === "changeRowsPerPage" ? 18 : _context7.t0 === "filterChange" ? 22 : _context7.t0 === "resetFilters" ? 22 : 25;
                    break;

                  case 3:
                    _this.page = state.page;

                    _this.scrollToTop();

                    _context7.next = 7;
                    return _this.loadRows();

                  case 7:
                    return _context7.abrupt("break", 26);

                  case 8:
                    split = state.announceText.replace("Table now sorted by", "").trim().split(":");
                    column = split[0].trim();
                    direction = split[1].trim();
                    direction = direction === "descending" ? "desc" : "asc";

                    if (_this.props.resetPageOnFilterChange) {
                      _this.page = 0;
                    }

                    _this.setState({
                      sortColumn: column,
                      sortDirection: direction,
                      sortColumnIndex: state.activeColumn
                    }, _this.loadRows);

                    return _context7.abrupt("break", 26);

                  case 15:
                    _context7.next = 17;
                    return _this.onSearch(state.searchText);

                  case 17:
                    return _context7.abrupt("break", 26);

                  case 18:
                    _this.scrollToTop();

                    if (_this.props.resetPageOnFilterChange) {
                      _this.page = 0;
                    } else {
                      _this.page = state.page;
                    }

                    _this.setState({
                      rowsPerPage: state.rowsPerPage
                    }, _this.loadRows);

                    return _context7.abrupt("break", 26);

                  case 22:
                    if (_this.props.resetPageOnFilterChange) {
                      _this.page = 0;
                    }

                    _this.setState({
                      filterList: state.filterList
                    }, _this.loadRows);

                    return _context7.abrupt("break", 26);

                  case 25:
                    return _context7.abrupt("break", 26);

                  case 26:
                  case "end":
                    return _context7.stop();
                }
              }
            }, _callee7);
          }));

          function onTableChange(_x8, _x9) {
            return _onTableChange.apply(this, arguments);
          }

          return onTableChange;
        }(),
        page: _this.page,
        count: _this.props.serverSide ? _this.state.count : undefined,
        rowsPerPage: _this.state.rowsPerPage,
        rowsPerPageOptions: _this.state.rowsPerPageOptions,
        textLabels: {
          body: {
            noMatch: _this.props.emptyMessage,
            columnHeaderTooltip: function columnHeaderTooltip(column) {
              return "Sort by ".concat(column.label);
            }
          }
        },
        customToolbar: _this.props.customToolbar,
        customToolbarSelect: function customToolbarSelect(selectedRows, displayData) {
          if (!_this.props.bulkActions || _this.props.bulkActions.length === 0) {
            return null;
          }

          return /*#__PURE__*/_react.default.createElement("div", {
            style: {
              marginRight: "10px"
            }
          }, _this.props.bulkActions.map(function (b) {
            return /*#__PURE__*/_react.default.createElement(_Button.default, {
              key: b.display,
              style: {
                marginLeft: "5px"
              },
              className: "prmbl-advancedTable-bulkaction",
              id: "prmbl-advancedtable-bulkaction-".concat(b.display),
              onClick: function onClick() {
                return b.action(selectedRows);
              },
              variant: "contained"
            }, b.display);
          }));
        },
        onRowsSelect: _this.props.onRowsSelect,
        onRowClick: _this.props.onRowClick,
        filter: _this.props.showFilter,
        search: _this.props.showSearch,
        viewColumns: _this.props.viewColumns,
        selectableRows: _this.props.selectableRows,
        searchText: _this.search,
        serverSide: _this.props.serverSide,
        customSort: _this.props.serverSide ? undefined : _this.customSort,
        rowsSelected: _this.props.rowsSelected,
        onImport: _this.props.onImport,
        customSearch: _this.props.customSearch
      };
      return options;
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "deselectAllRows", function () {
      _this.props.onRowsSelect && _this.props.onRowsSelect([], []);
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "customSort", function (data, colIndex, order) {
      return data.sort(function (a, b) {
        if (a.data === undefined) a = "";
        if (b.data === undefined) b = "";
        a = a.data[colIndex];
        b = b.data[colIndex];

        if (a.props && a.props.date) {
          a = a.props.date;
        }

        if (b.props && b.props.date) {
          b = b.props.date;
        }

        return (typeof a.localeCompare === "function" ? a.localeCompare(b) : a - b) * (order === "asc" ? 1 : -1);
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "loadingRows", function (columns) {
      var results = [];

      for (var i = 0; i < _this.state.rowsPerPage; i++) {
        var rows = [];

        for (var j = 0; j < columns.length; j++) {
          rows.push("");
        }

        results.push(rows);
      }

      return results;
    });
    props.columns.forEach(function (c) {
      return _this.hiddenColumns[c.name] = c.options && c.options.display || "true";
    });
    _this.state = {
      count: 0,
      rowsPerPage: _this.props.rowsPerPage || 10,
      rowsPerPageOptions: props.rowsPerPageOptions && props.rowsPerPageOptions.length > 0 ? props.rowsPerPageOptions : [10, 25, 50, 100],
      loading: true,
      dataRetrieved: false,
      retrievedRows: [["Loading data..."]],
      sortColumn: _this.props.initialSortColumn || "",
      sortDirection: _this.props.initialSortDirection || "",
      filterList: [],
      enableDebounce: _this.props.enableDebounce == null ? true : _this.props.enableDebounce,
      sortColumnIndex: _this.props.initialSortColumnIndex || 0,
      preloadedDataExpirationSeconds: props.preloadedDataExpirationSeconds || 15
    };
    _this.ref = /*#__PURE__*/_react.default.createRef();
    return _this;
  }

  (0, _createClass2.default)(AdvancedTableWrapper, [{
    key: "componentDidMount",
    value: function () {
      var _componentDidMount = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee8() {
        return _regenerator.default.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                this.startPreloadedDataClearer();
                this.props.onRef && this.props.onRef(this);
                _context8.next = 4;
                return this.loadRows();

              case 4:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));

      function componentDidMount() {
        return _componentDidMount.apply(this, arguments);
      }

      return componentDidMount;
    }()
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.preloadedDataClearer && clearInterval(this.preloadedDataClearer);
      this.preloadedDataClearer = null;
      this.preloadedData.clear();
      this.props.onRef && this.props.onRef(null);
    }
  }, {
    key: "render",
    value: function render() {
      var retrievedRows = this.state.retrievedRows;
      var options = this.buildOptions();
      var columns = this.buildColumns(); // Any changes to the search bar text or retrieved rows count causes a flicker of the component Search bar.
      // Removing the searchText and count properties from the options ONLY for the component key prop fixes this issue.

      var keyOptions = _objectSpread({}, options);

      delete keyOptions.searchText;
      delete keyOptions.count;
      var tableKey = JSON.stringify(keyOptions);

      if (this.state.loading) {
        return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
          ref: this.ref
        }), /*#__PURE__*/_react.default.createElement(_AdvancedTable.default, {
          key: tableKey,
          data: this.loadingRows(columns),
          options: options,
          columns: this.buildLoadingColumns()
        }));
      }

      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
        ref: this.ref
      }), /*#__PURE__*/_react.default.createElement(_AdvancedTable.default, {
        key: tableKey,
        data: retrievedRows,
        options: options,
        columns: columns,
        compact: this.props.compact
      }));
    }
  }, {
    key: "tableState",
    get: function get() {
      return {
        sortColumn: this.state.sortColumn,
        sortDirection: this.state.sortDirection,
        page: this.page,
        rowsPerPage: this.state.rowsPerPage,
        search: this.search,
        filterList: this.state.filterList,
        sortColumnIndex: this.state.sortColumnIndex
      };
    }
  }]);
  return AdvancedTableWrapper;
}(_react.default.Component);

exports.AdvancedTableWrapper = AdvancedTableWrapper;
(0, _defineProperty2.default)(AdvancedTableWrapper, "defaultProps", {
  showFilter: false,
  showSearch: false,
  viewColumns: true,
  serverSide: true,
  compact: false,
  selectableRows: "none"
});
(0, _defineProperty2.default)(AdvancedTableWrapper, "defaultActionMenuColumn", function () {
  return {
    name: "actions",
    label: "Actions",
    options: {
      viewColumns: false,
      sort: false,
      searchable: false,
      filter: false
    }
  };
});

var _default = (0, _notistack.withSnackbar)(AdvancedTableWrapper);

exports.default = _default;